<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/package/"
                       data-key="packages"
                       :extra-params="{
                         with_expired: withExpired,
                         type_id: packageTypeId,
                       }"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template #item.create_at="{value}">
      {{ $parseDate(value) }}
    </template>
    <template #item.account="{item}">
      {{ $t('name', {surname: item.account.surname, given_name: item.account.given_name}) }}
    </template>
    <template #item.status="{value}">
      {{ $t(BOOKING_STATUS_LABEL[value]) }}
    </template>
    <template v-slot:item.actions="{item}">
<!--      <v-row>-->
<!--        <v-col>-->
<!--          <font-awesome-icon icon="edit"-->
<!--                             @click="editItem(item)"></font-awesome-icon>-->
<!--        </v-col>-->
<!--      </v-row>-->
    </template>
  </RemotePaginatedList>
</template>

<script>
import _ from 'lodash';
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import {BOOKING_STATUS_LABEL} from "@/constants";

export default {
  name: 'AdminPackagePurchaseRecordList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    packageTypeId: String,
    withExpired: Boolean,
    hideActions: Boolean,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        // {text: root.$t('admin_acc_package_type.name_en'), value: 'name_en', contains: true},
        // {text: root.$t('admin_acc_package_type.name_zh'), value: 'name_zh', contains: true},
        // {text: root.$t('admin_acc_package_type.valid_from'), value: 'valid_from', date_range: true},
        // {text: root.$t('admin_acc_package_type.valid_until'), value: 'valid_until', date_range: true},
      ]
    })

    // Data Table
    const headers = computed(() => {

      let headers = [
        {text: root.$t('admin_acc_package.create_at'), value: 'create_at'},
        {text: root.$t('admin_acc_package.account'), value: 'account'},
        {text: root.$t('admin_acc_package.type'), value: 'type.name'},
        {text: root.$t('admin_acc_package.status'), value: 'status'},
      ];

      if (!props.hideActions) {
        headers.push({text: '', value: 'actions'});
      }

      return headers
    });
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const editItem = function (item) {
      emit('edit', item);
    };


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,

      BOOKING_STATUS_LABEL,
    }
  }
}
</script>
